module.exports = __webpack_public_path__ + "img/e_r_logo_dark.9b88402a.png";